import { ItemJsEnv } from "../item_js_env";

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setRrRequestParams = (R3_COMMON: r3_common, pageOption: any, isSoloare?: boolean) => {
  const R3_ITEM = new r3_item();
  if (isSoloare) {
    R3_COMMON.addPlacementType('item_page');
  } else {
    R3_COMMON.addPlacementType(`item_page.${pageOption.placementNameItemExternalSite}`);
    R3_COMMON.addPlacementType(`item_page.${pageOption.placementNameItemNormalUpper}`);
    R3_COMMON.addPlacementType(`item_page.${pageOption.placementNameItemNormalLower}`);
  }
  R3_COMMON.addCategoryHintId(pageOption.sCategoryCode);
  R3_ITEM.setId(pageOption.catalogItemCode);
  R3_ITEM.setName(pageOption.catalogItemName);
};

// RRサーバにリクエストを送る時に設定する、画面によって変わるパラメータ。
export const setAddToCartPageRrRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
  const R3_ITEM = new r3_item();
  R3_COMMON.addPlacementType(`add_to_cart_page.${pageOption.placementNameItemMyCatalogModal}`);

  R3_ITEM.setId(pageOption.catalogItemCode);
  R3_ITEM.setName(pageOption.catalogItemName);
};

export const createRrRequestParam = (model: ItemJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setRrRequestParams,
    pageOption: {
      placementNameItemExternalSite: model.rrAreaProfileItemExternalSite.placementName,
      placementNameItemNormalUpper: model.rrAreaProfileItemNormalUpper.placementName,
      placementNameItemNormalLower: model.rrAreaProfileItemNormalLower.placementName,
      sCategoryCode: model.sCategoryCode,
      catalogItemCode: model.catalogItemCode,
      catalogItemName: model.catalogItemName
    }
  };
}

export const createAddToCartPageRrRequestParam = (model: ItemJsEnv) => {
  return {
    isLogin: model.isLogin,
    userId: model.userId,
    userTracking: model.userTracking,
    userSegments: model.userSegments,
    setRrRequestParams: setAddToCartPageRrRequestParams,
    pageOption: {
      placementNameItemExternalSite: model.rrAreaProfileItemExternalSite.placementName,
      placementNameItemNormalUpper: model.rrAreaProfileItemNormalUpper.placementName,
      placementNameItemNormalLower: model.rrAreaProfileItemNormalLower.placementName,
      sCategoryCode: model.sCategoryCode,
      catalogItemCode: model.catalogItemCode,
      catalogItemName: model.catalogItemName
    }
  };
}
